import { isConsoleOn } from "../authConfig"

export const consolelog = (msg:any, data?:any)=>{
    if(isConsoleOn){
        if(data){
            console.log(msg,data)
        }else{
            console.log(msg)
        }
    }
}